module.exports = __webpack_public_path__ + "img/menu-icon-open.f48e3812.svg";